/* MFG blog TOC: drop below the sticky header in the same frame it returns
   (card 1219780817610461). main.js only updates --header-end 300 ms after
   StoreHeader.show(), so the #732 sticky rule lags behind the header.
   Desktop/tablet (>= 769px) only; the mobile drawer is untouched.

   A reload can restore the page already scrolled, with the header either
   still shown or already is-out, and bfcache fires pageshow instead of load.
   Read scrollY and the header state immediately. Otherwise shownHeight stays
   0 and toc-header-shown never turns on for that view. */
(function () {
  var header = document.querySelector('store-header');
  var article = document.querySelector('.js-article');
  if (!header || !article) return;
  if (!article.querySelector('.blog__glossory, .article_right')) return;
  if (header.__rsTocSticky) return;
  header.__rsTocSticky = true;

  var desktopMq = window.matchMedia('(min-width: 769px)');
  var SHOWN_CLASS = 'toc-header-shown';
  var shownHeight = 0;
  var settleTimer = null;
  var rafId = 0;
  var rafMeasure = false;
  var lastOut = null;

  function pageScrollY() {
    var y = 0;
    var samples = [window.scrollY, window.pageYOffset];
    var root = document.documentElement;
    if (root) samples.push(root.scrollTop);
    for (var i = 0; i < samples.length; i++) {
      if (typeof samples[i] === 'number' && samples[i] > y) y = samples[i];
    }
    return y;
  }

  function isOut() {
    return header.classList.contains('is-out');
  }

  function disclosureEl() {
    return header.querySelector('.main-menu__disclosure');
  }

  function menuVarPx() {
    if (!header.style || !header.style.getPropertyValue) return 0;
    return parseFloat(header.style.getPropertyValue('--menu-height')) || 0;
  }

  /* is-out (and the 300ms return) collapses the menu with max-height, so
     offsetHeight is not the settled shown height yet. */
  function menuIsCollapsed() {
    if (isOut()) return true;
    var disclosure = disclosureEl();
    if (!disclosure) return false;
    var box = disclosure.offsetHeight || 0;
    var full = disclosure.scrollHeight || 0;
    return full > box + 1;
  }

  function measureShownHeight() {
    var live = header.offsetHeight || 0;
    if (menuIsCollapsed()) {
      if (!shownHeight) {
        var disclosure = disclosureEl();
        var box = disclosure && disclosure.offsetHeight ? disclosure.offsetHeight : 0;
        var extra = 0;
        var menuVar = menuVarPx();
        if (menuVar > box) extra = menuVar - box;
        else if (disclosure && disclosure.scrollHeight && disclosure.scrollHeight > box + 1) {
          extra = disclosure.scrollHeight - box;
        }
        if (live && extra) shownHeight = live + extra;
      }
      return;
    }
    if (live) shownHeight = live;
  }

  function clear() {
    article.classList.remove(SHOWN_CLASS);
    article.style.removeProperty('--toc-header-end');
  }

  function writeOffset() {
    var end = header.getBoundingClientRect().top + shownHeight;
    article.style.setProperty('--toc-header-end', end.toFixed(1) + 'px');
    article.classList.add(SHOWN_CLASS);
    revealFocused();

    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      var before = shownHeight;
      measureShownHeight();
      if (isOut() || !desktopMq.matches || !shownHeight || shownHeight === before) return;
      if (!article.classList.contains(SHOWN_CLASS)) return;
      var settled = header.getBoundingClientRect().top + shownHeight;
      article.style.setProperty('--toc-header-end', settled.toFixed(1) + 'px');
      revealFocused();
    }, 350);
  }

  function syncNow(forceMeasure) {
    var y = pageScrollY();
    var out = isOut();

    if (!desktopMq.matches) {
      clearTimeout(settleTimer);
      settleTimer = null;
      lastOut = out;
      clear();
      return;
    }

    if (out) {
      clearTimeout(settleTimer);
      settleTimer = null;
      measureShownHeight();
      lastOut = true;
      clear();
      return;
    }

    var returned = lastOut === true;
    if (!forceMeasure && !returned && shownHeight && article.classList.contains(SHOWN_CLASS)) {
      lastOut = false;
      return;
    }

    if (forceMeasure || !shownHeight) measureShownHeight();
    lastOut = false;

    /* At the top, before the header has ever hidden, #732's --header-end rule
       already places the TOC. Applying the class there would only drop the
       300ms ease on a page that has not scrolled. */
    if (y <= 0 && !returned && !article.classList.contains(SHOWN_CLASS)) return;

    if (!shownHeight) {
      clear();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { syncNow(true); }, 350);
      return;
    }

    writeOffset();
  }

  function schedule(forceMeasure) {
    if (forceMeasure) rafMeasure = true;
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      var measure = rafMeasure;
      rafId = 0;
      rafMeasure = false;
      syncNow(measure);
    });
  }

  function onHeaderClass() {
    var out = isOut();
    if (out === lastOut) return;
    syncNow(false);
  }

  /* Card 1219791283954477: the editorial TOC scrolls inside its own box while
     sticky (article-mfg-toc.css). Keep a keyboard-focused item, focus ring
     included, inside that box when it takes focus and whenever the box
     resizes. When the header comes back the box snaps shorter in the same
     task as toc-header-shown, so writeOffset() reveals there too rather than
     waiting for ResizeObserver, which may be missing. Scrolls the TOC only,
     never the page, so the header state does not change.
     Mouse focus is left alone: scrolling between mousedown and mouseup would
     move the item out from under the pointer and drop the click. */
  var toc = article.querySelector('.blog__glossory');
  var FOCUS_GAP = 8;

  function keyboardFocused(item) {
    try {
      return item.matches(':focus-visible');
    } catch (err) {
      return true;
    }
  }

  function revealFocused() {
    if (!toc || !desktopMq.matches) return;
    var item = document.activeElement;
    if (!item || item === toc || !toc.contains(item) || !keyboardFocused(item)) return;
    var view = toc.clientHeight;
    if (!view || toc.scrollHeight <= view) return;
    var boxTop = toc.getBoundingClientRect().top + (toc.clientTop || 0);
    var rect = item.getBoundingClientRect();
    var above = boxTop + FOCUS_GAP - rect.top;
    var below = rect.bottom + FOCUS_GAP - (boxTop + view);
    if (above > 0) toc.scrollTop -= above;
    else if (below > 0) toc.scrollTop += Math.min(below, -above);
  }

  if (toc) {
    window.addEventListener('focusin', revealFocused);
    if (typeof ResizeObserver === 'function') new ResizeObserver(revealFocused).observe(toc);
  }

  syncNow(true);

  new MutationObserver(onHeaderClass).observe(header, {
    attributes: true,
    attributeFilter: ['class']
  });

  window.addEventListener('load', function () { schedule(true); });
  window.addEventListener('pageshow', function () { schedule(true); });
  window.addEventListener('resize', function () { schedule(true); });
  window.addEventListener('scroll', function () { schedule(false); }, { passive: true });

  if (document.readyState === 'complete') schedule(true);
})();
